import React from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import { FaPalette, FaMagic, FaEye, FaImage, FaInstagram } from "react-icons/fa";
import Helmet from "../components/Helmet/Helmet";
import Gallery from "../components/Gallery";
import InstagramSection from "../components/UI/InstagramSection";
import heroImage from "../assets/all-images/bg13.jpg";
import { siteConfig } from "../utils/site";
import "../styles/luxury-pages.css";
import "../styles/world-class-luxury.css";
import "../styles/instagram.css";

export default function GalleryPage() {
  return (
    <>
      <Helmet>
        <title>Gallery | Roha Jewellery — Ethiopian Gemstone Designs & Instagram</title>
        <meta
          name="description"
          content="Explore Roha Jewellery's full gallery — AI-generated concepts, handcrafted designs, and our latest Instagram posts from @rohajewellery16."
        />
        <link rel="canonical" href={`${siteConfig.url}/ai-gallery`} />
      </Helmet>

      <main className="luxury-page">
        {/* Hero */}
        <section className="luxury-page__hero" aria-labelledby="gallery-hero-heading">
          <div className="luxury-page__hero-bg">
            <img src={heroImage} alt="Roha Jewellery gallery background" />
          </div>
          <div className="luxury-page__hero-overlay"></div>
          <div className="luxury-page__hero-gradient"></div>
          <Container>
            <div className="luxury-page__hero-content">
              <div className="luxury-page__hero-eyebrow">
                <FaPalette aria-hidden="true" /> Design Gallery
              </div>
              <h1 id="gallery-hero-heading" className="luxury-page__hero-title">
                Ethiopian Jewellery <span className="luxury-page__hero-title-gradient">Gallery</span>
              </h1>
              <p className="luxury-page__hero-subtitle">
                Browse our handcrafted designs, AI-generated concepts, and the latest pieces
                from our Instagram — all in one place.
              </p>
              <div className="luxury-page__hero-actions">
                <Link to="/design-request" className="wc-button wc-button-primary wc-button-lg">
                  Request a Custom Design
                </Link>
                <a
                  href="https://www.instagram.com/rohajewellery16/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="wc-button wc-button-secondary"
                >
                  <FaInstagram className="me-2" /> Follow on Instagram
                </a>
              </div>
              <div className="luxury-page__hero-tags">
                <span className="luxury-page__hero-tag"><FaMagic aria-hidden="true" /> AI Generated</span>
                <span className="luxury-page__hero-tag"><FaImage aria-hidden="true" /> Handcrafted</span>
                <span className="luxury-page__hero-tag"><FaInstagram aria-hidden="true" /> @rohajewellery16</span>
                <span className="luxury-page__hero-tag"><FaEye aria-hidden="true" /> Visual Exploration</span>
              </div>
            </div>
          </Container>
        </section>

        {/* Instagram Feed — full grid */}
        <section className="luxury-section" aria-labelledby="instagram-gallery-heading">
          <Container>
            <div className="luxury-section__heading">
              <div className="luxury-section__eyebrow">
                <FaInstagram aria-hidden="true" /> @rohajewellery16
              </div>
              <h2 id="instagram-gallery-heading" className="luxury-section__title">
                Our Jewellery Gallery
              </h2>
              <p className="luxury-section__subtitle">
                Every image you see here is a real piece from Roha Jewellery — handcrafted in Addis Ababa
                and posted on our Instagram. Click any image to visit our profile.
              </p>
            </div>
            <InstagramSection compact={false} />
          </Container>
        </section>

        {/* AI Concepts */}
        <section className="luxury-section luxury-section--soft" aria-labelledby="ai-gallery-heading">
          <Container>
            <div className="luxury-section__heading">
              <div className="luxury-section__eyebrow">
                <FaEye aria-hidden="true" /> AI Design Ideas
              </div>
              <h2 id="ai-gallery-heading" className="luxury-section__title">
                AI-Generated Jewellery Concepts
              </h2>
              <p className="luxury-section__subtitle">
                These AI-generated visuals serve as creative inspiration for custom jewellery commissions.
              </p>
            </div>
            <div className="luxury-card">
              <div className="luxury-card__body">
                <Gallery />
              </div>
            </div>
          </Container>
        </section>

        {/* CTA */}
        <section className="luxury-section luxury-section--dark" aria-labelledby="gallery-cta-heading">
          <Container>
            <div className="luxury-section__heading">
              <h2 id="gallery-cta-heading" className="luxury-section__title">
                Ready to Transform Inspiration into Reality?
              </h2>
              <p className="luxury-section__subtitle">
                Found a piece you love? Commission a custom design or shop our ready-made collection.
              </p>
            </div>
            <div className="text-center" style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/design-request" className="wc-button wc-button-primary wc-button-lg">
                Start Custom Design
              </Link>
              <Link to="/products" className="wc-button wc-button-secondary">
                Shop Collection
              </Link>
              <a
                href="https://www.instagram.com/rohajewellery16/"
                target="_blank"
                rel="noopener noreferrer"
                className="wc-button wc-button-secondary"
              >
                <FaInstagram className="me-2" /> Follow Us
              </a>
            </div>
          </Container>
        </section>
      </main>
    </>
  );
}